import { Graph } from "../generated/graph";

export class HelperWebsite {
  static websites: Graph.ConfigurationWebsite [] = [];

  static getSiteName(siteId) {
    const site = this.websites.filter(website => website.siteId === siteId);
    return site[0].siteName;
  }

  static getSiteColor(siteId) {
    const site = this.websites.filter(website => website.siteId === siteId);
    return site[0].siteColor;
  }

  static getAll() {
    return this.websites;
  }
}